module.exports = __webpack_public_path__ + "img/yaoqing_2.ccfd32ef.png";